export const nen3140SelectOptions = {
    nen3140Score: [
        { value: 'OK', text: 'OK: Geen afwijkingen' },
        { value: 'A', text: 'A: Levensgevaar (direct verhelpen of spanningsloos maken)' },
        { value: 'B', text: 'B: Zeer gevaarlijk (verhelpen binnen uiterlijk enkele dagen)' },
        { value: 'C', text: 'C: Gevaarlijk (verhelpen binnen één maand)' },
        { value: 'D', text: 'D: Matig gevaar (verhelpen binnen half jaar)' },
        { value: 'E', text: 'E: Geen gevaar (betreft normafwijking of afwijking van bijv. tekening)' },
        { value: 'F', text: 'F: Installatie of onderdeel is niet betrouwbaar' },
        { value: 'NVT', text: 'Niet van toepassing' },
    ],
};
